var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgMagnifyingGlass(props) {
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.192 1.396c-3.197 0-5.788 2.6-5.788 5.806s2.59 5.805 5.788 5.805c3.197 0 5.788-2.6 5.788-5.805 0-3.207-2.591-5.806-5.788-5.806zm0 10.86A5.048 5.048 0 012.15 7.198a5.048 5.048 0 015.042-5.056 5.048 5.048 0 015.041 5.056 5.048 5.048 0 01-5.041 5.056z",
    fill: "url(#".concat(_id4, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.192 1.032c-3.396 0-6.15 2.761-6.15 6.167 0 3.406 2.754 6.167 6.15 6.167 3.395 0 6.149-2.761 6.149-6.167 0-3.406-2.754-6.167-6.15-6.167zm0 11.673c-3.033 0-5.49-2.465-5.49-5.506 0-3.041 2.457-5.506 5.49-5.506 3.032 0 5.49 2.465 5.49 5.506 0 3.041-2.458 5.506-5.49 5.506z",
    fill: "url(#".concat(_id5, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.116 11.498a4.705 4.705 0 002.351-6.212 4.68 4.68 0 00-6.194-2.359A4.705 4.705 0 002.921 9.14a4.68 4.68 0 006.195 2.358z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.644 2.362c2.666.804 4.176 3.624 3.374 6.298a5.038 5.038 0 01-6.28 3.384C3.07 11.24 1.56 8.42 2.364 5.746a5.038 5.038 0 016.28-3.384z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.82 13.332c-.015-.024-.035-.048-.054-.073l-.005-.005a1.1 1.1 0 00-.073-.08l-2.64-2.63a5.76 5.76 0 01-.692.836c-.262.263-.54.491-.834.695l2.659 2.611c.417.418 1.09.418 1.507 0 .366-.367.41-.938.131-1.354z",
    fill: "url(#".concat(_id6, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.937 14.38a.45.45 0 10-.001-.898.45.45 0 00.001.898z",
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _id,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.001 0 0 20.06 4.25 .858)"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BAF6",
    stopOpacity: 0.5
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#36BBF6",
    stopOpacity: 0.49
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A2DFFA",
    stopOpacity: 0.23
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E5F6FD",
    stopOpacity: 0.06
  })), _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id2,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.862 0 0 11.8969 15.132 10.975)"
  }, _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BAF6",
    stopOpacity: 0.5
  })), _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#36BBF6",
    stopOpacity: 0.49
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A2DFFA",
    stopOpacity: 0.23
  })), _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E5F6FD",
    stopOpacity: 0.06
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id3,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.67484 0 0 1.67977 14.599 11.242)"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA30"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB32E"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 5.813,
    y1: 2.425,
    x2: 10.999,
    y2: 20.274,
    gradientUnits: "userSpaceOnUse"
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", null)), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#889FA2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 8.99,
    y1: 17.161,
    x2: 4.851,
    y2: -5.617,
    gradientUnits: "userSpaceOnUse"
  }, _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", null)), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#889FA2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 11.193,
    y1: 13.865,
    x2: 14.465,
    y2: 12.033,
    gradientUnits: "userSpaceOnUse"
  }, _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", null)), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#889FA2"
  })))));
}
export default SvgMagnifyingGlass;